<template>
  <div class="search-section">
    <SearchBarNew
      v-model="search"
      :label="searchTitle"
      :search-results="searchResults"
      linear-label
      custom-key="url"
      @select-role="goToRolePage"
    />
    <p class="roles-description">Most in demand roles</p>
    <div class="roles-options">
      <FilterButton
        v-for="(role, index) in rolesInDemand"
        :key="index"
        :filter-title="
          isMobile
            ? (role.title_mobile.replace('job', '') ??
              role.title.replace('job', ''))
            : role.title.replace('job', '')
        "
        :is-active="isRoleActive(role.url)"
        :show-close-icon="false"
        @filter-clicked="goToRolePage(role)"
      />
    </div>
  </div>
</template>

<script>
import FilterButton from '~/components/Common/UI/FilterButton/FilterButton.vue';
import SearchBarNew from '~/components/Common/UI/SearchBarNew/SearchBarNew.vue';
import isMobile from '~/mixins/responsive';
import { useRolesStore } from '~/stores/roles';
export default {
  components: {
    SearchBarNew,
    FilterButton,
  },
  mixins: [isMobile],
  props: {
    searchTitle: {
      type: String,
      default: 'Search roles',
    },
  },
  data() {
    return {
      search: '',
      rolesStore: useRolesStore(),
    };
  },
  computed: {
    allRoles() {
      return this.rolesStore.roles;
    },
    rolesInDemand() {
      return this.rolesStore.rolesInDemand;
    },
    searchResults() {
      if (!this.search) return [];
      return this.allRoles.filter((role) =>
        this.search
          .split(' ')
          .some((word) => role.searchTitle.includes(word.toLowerCase()))
      );
    },
  },
  methods: {
    goToRolePage(role) {
      this.trackCta(role.title);

      this.$router.push({
        name: 'slug',
        params: {
          slug: role.url,
        },
      });
    },
    trackCta(roleName) {
      this.$analytics.track('Role_click', {
        role_name: roleName,
        page_name:
          this.$route.name === 'slug' ? 'Roles pages' : 'How it works page',
      });
    },
    isRoleActive(roleUrl) {
      return this.$route.params.slug === roleUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './SearchSection.scss';
</style>
